import React from 'react';
export function VolumesDetail() {
  const volumes = [{
    vol: '📘 Tomo 1 — 1.º Grado:',
    title: 'Mi Familia, Mi Escuela y Mi Barrio',
    content: 'Diversidad familiar / Escuela como institución / Barrio y servicios / Antes y ahora / Efemérides'
  }, {
    vol: '📗 Tomo 2 — 2.º Grado:',
    title: 'Mi Comunidad, Los Trabajos y Las Historias de Vida',
    content: 'Instituciones / Municipio / Circuitos productivos / Migraciones / Diversidad cultural / Ambientes'
  }, {
    vol: '📕 Tomo 3 — 3.º Grado:',
    title: 'Las Instituciones, El Trabajo Colectivo y Los Pueblos Originarios',
    content: 'Estado y poderes / Cooperativas / Pueblos originarios con enfoque intercultural / Problemas ambientales'
  }, {
    vol: '📙 Tomo 4 — 4.º Grado:',
    title: 'La Provincia, La Conquista y Los Ambientes de Argentina',
    content: 'Gobierno provincial / Mapas y cartografía / Conquista española / Recursos naturales / Federalismo'
  }, {
    vol: '📘 Tomo 5 — 5.º Grado:',
    title: 'Argentina en América Latina: Historia, Geografía y Organización Nacional',
    content: 'MERCOSUR / Estado Nacional / Historia 1810-1880 / Circuitos productivos / Modelo agroexportador'
  }, {
    vol: '📙 Tomo 6 — 6.º Grado:',
    title: 'Argentina Contemporánea: Democracia, Economía y El Mundo',
    content: 'Siglo XX / Peronismo / Dictadura y Democracia / Globalización / ODS / Cambio climático / DDHH'
  }];
  const includes = ['Actividades fotocopiables organizadas por unidad (60 páginas por tomo)', 'Solucionario completo con criterios de corrección para cada actividad', 'Lecturas adaptadas a cada grado con vocabulario apropiado', 'Efemérides del año escolar con guiones, glosas y actividades listas', 'Mapas, infografías y líneas de tiempo para completar', 'Proyectos integradores por unidad', 'Glosario visual y autoevaluación del alumno', 'Bibliografía curricular alineada a los NAP'];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border" data-id="element-271">
      <div className="max-w-5xl mx-auto" data-id="element-272">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-273">
          Lo que <span className="text-brand-accent" data-id="element-274">recibís</span>
        </h2>
        <div className="max-w-3xl mx-auto flex flex-col gap-8 mb-20" data-id="element-275">
          <div className="bg-brand-card border border-brand-accent/40 rounded-2xl p-6 md:p-8" data-id="element-276">
            <div className="mb-8 text-center" data-id="element-277">
              <h3 className="text-2xl md:text-3xl font-heading font-bold uppercase mb-2 text-brand-accent" data-id="element-278">
                📚 CIENCIAS SOCIALES PRIMARIA — 6 Tomos
              </h3>
              <p className="text-white/70 text-base" data-id="element-279">
                Para docentes de Ciencias Sociales de 1.º a 6.º grado de
                primaria
              </p>
            </div>
            <div className="space-y-6" data-id="element-280">
              {volumes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-281">
                  <p className="text-white/90 text-base leading-relaxed" data-id="element-282">
                    <span className="font-bold text-white mr-2 block md:inline" data-id="element-283">
                      {item.vol}
                    </span>
                    <span className="italic text-white/80 block md:inline md:mr-2" data-id="element-284">
                      {item.title}
                    </span>
                    <span className="text-white/70 text-sm block mt-1 md:mt-0" data-id="element-285">
                      ({item.content})
                    </span>
                  </p>
                </div>)}
            </div>
          </div>
        </div>
        <div className="max-w-3xl mx-auto bg-brand-card rounded-2xl p-8 md:p-12 border-2 border-brand-accent/40" data-id="element-286">
          <h3 className="text-2xl md:text-3xl font-heading font-bold mb-8 md:mb-10 text-center text-brand-accent" data-id="element-287">
            Cada tomo incluye:
          </h3>
          <div className="flex flex-col gap-5 md:gap-6" data-id="element-288">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-289">
                <div className="flex-shrink-0 w-8 h-8 bg-[#0097A7] rounded-md flex items-center justify-center mt-0.5 text-white font-black" data-id="element-290">
                  ✓
                </div>
                <span className="font-bold text-white text-lg md:text-xl leading-snug" data-id="element-291">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}